/**
 * @generated SignedSource<<048a068648964d2244a4ca8f2a846442>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveEmailTemplateVariantInput = {
  id: string;
  language: string;
};
export type EmailTemplateDetailsViewRemoveVariantMutation$variables = {
  input: RemoveEmailTemplateVariantInput;
};
export type EmailTemplateDetailsViewRemoveVariantMutation$data = {
  readonly removeEmailTemplateVariant: {
    readonly id: string;
    readonly primaryLanguage: string;
    readonly variants: ReadonlyArray<{
      readonly htmlContent: string | null | undefined;
      readonly language: string;
      readonly preheader: string | null | undefined;
      readonly subject: string | null | undefined;
      readonly textContent: string | null | undefined;
    }>;
  };
};
export type EmailTemplateDetailsViewRemoveVariantMutation = {
  response: EmailTemplateDetailsViewRemoveVariantMutation$data;
  variables: EmailTemplateDetailsViewRemoveVariantMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "removeEmailTemplateVariant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryLanguage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailTemplateVariant",
        "kind": "LinkedField",
        "name": "variants",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preheader",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "htmlContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textContent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplateDetailsViewRemoveVariantMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailTemplateDetailsViewRemoveVariantMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c1a4c7b30143a4c6e867c9768435290f",
    "id": null,
    "metadata": {},
    "name": "EmailTemplateDetailsViewRemoveVariantMutation",
    "operationKind": "mutation",
    "text": "mutation EmailTemplateDetailsViewRemoveVariantMutation(\n  $input: RemoveEmailTemplateVariantInput!\n) {\n  removeEmailTemplateVariant(input: $input) {\n    id\n    primaryLanguage\n    variants {\n      language\n      subject\n      preheader\n      htmlContent\n      textContent\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5718871bad4f4ddcf50795f51601b021";

export default node;
